import { APP_BASE_HREF } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from '@app/_core/services/app.service';
import { FormDataService } from '@app/_core/services/form-data.service';
import { ManagerService } from '@app/_core/services/manager.service';
import { QueuesService } from '@app/_core/services/queues.service';
import { WebStorageService } from '@app/_core/services/webstorage.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { DialerService } from '@app/_core/services/dialer.service';
import { LoaderService } from '@app/_core/services/loader.service';
import { MainControllerComponent } from 'src/app/pages/queue/dialer/MainController.component';
import { CasesComponent } from '@app/pages/queue/common/case-detail/cases/cases.component';
import { FlexibleStoreService } from '@app/_core/services/flexible-storage.service';
@Component({
  selector: 'app-case-assigner',
  templateUrl: './case-assigner.component.html',
  styleUrl: './case-assigner.component.scss'
})
export class CaseAssignerComponent implements OnChanges {
  @Input() QueueName:string;
  @Input() AgentName:string;
  @Input() caseAssignerInput:any;
  @Input() field :any;
  @Input() caseStatusID :any;
  @Input() caseID :any;
  @Input() group :any;
  @Output() caseAssignerValue=new EventEmitter<any>();
  queueOptions: any;
  agentOptions: any;
  selectedAgent: string;
  selectedQueue: string;
  isErrorMsgRequired: boolean = true;
  company: any;
  constructor(
    private fb: FormBuilder,
    private queueService: QueuesService,
    private managerService: ManagerService,
    private route: ActivatedRoute,
    private router: Router,
    private modalService: BsModalService,
    public bsModalRef: BsModalRef,
    private webStorageService: WebStorageService,
    @Inject(APP_BASE_HREF) public baseHref: string,
    private formDataService: FormDataService,
    private appService: AppService,
    private casesComponent: CasesComponent,
    private queueServices: QueuesService,
      private cdref: ChangeDetectorRef,
      private dialerService: DialerService,
      private loaderService: LoaderService,
      private mainController: MainControllerComponent,
      private flexStore: FlexibleStoreService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.company = this.webStorageService.getItemFromSessionStorage('company');
    if(((this.company == 'Baycare' || this.company == 'Parkland') && !this.field.isRequired) || 
      ((this.company == 'Baycare' || this.company == 'Parkland') && this.field.isRequired && this.caseStatusID == '2')){
      this.isErrorMsgRequired = false;
    }else{
      this.isErrorMsgRequired = true;
    }
    if (!this.casesComponent.getCaseAssignerCallStatus()) {
      this.loadData();
    }
  }

  onDropdownChange(event)
  {
    if(event.target.id=='Agent'){
      this.selectedAgent=event.target.value;
    }
    else if(event.target.id=='Queue')
    {
      this.selectedQueue=event.target.value;
      this.selectedAgent=(this.company == 'Baycare' || this.company == 'Parkland') && this.selectedQueue != '-1' ? '0' : '-1';
      this.getAgents();
    }
    this.emitSelection(true);
  }

  private emitSelection(isUserAction: boolean = false): void {
    let finalValue = '';
    if(!this.isErrorMsgRequired && !this.field.isRequired && this.selectedQueue == '-1' && this.selectedAgent == '-1'){
      finalValue = '';
    }
    else{
      finalValue = (this.selectedQueue!=undefined ? this.selectedQueue.toString(): '-1').toString()+
              '|'+(this.selectedAgent!=undefined ? this.selectedAgent : (this.company == 'Baycare' || this.company == 'Parkland') ? '0' : '-1').toString()
    }

   this.caseAssignerValue.emit({
      "field":this.field,
      "group":this.group,
      "value":finalValue,
      "isUserAction":isUserAction
    });
 }
  // getQueues() {
  //   this.queueService.getCaseAssignerQueue().subscribe(response => {
  //     this.queueOptions = response.Response.Data;
  //   });
  // }

  getAgents() {
    if (this.selectedQueue) {
      let company = this.webStorageService.getItemFromSessionStorage('company');
      this.queueService.getCaseAssignerAgent(this.selectedQueue,this.caseID,company).subscribe(response => {
          this.agentOptions = response.Response.Data;
          this.disableBlocker(false);
        if(!this.field?.value?.includes("|")){
          this.selectedAgent = this.agentOptions?.find(x=>x.Name === 'Any Agent')?.Value ?? '-1';
          this.emitSelection();
        }
      });
    }
    else{
      this.disableBlocker(false);
    }
  }
  loadData()
  {
    if(!this.queueOptions)
    {
        //if (this.queueService.getIscasedetailComponent()) {

            let company = this.webStorageService.getItemFromSessionStorage('company');
            this.queueService.getCaseAssignerQueue(company).subscribe(response => {
                this.queueOptions = response.Response.Data;
                this.extractValues();
                //this.getAgents();
            });
        //}
    }
    else if (this.field?.value?.includes("|"))
    {
      this.extractValues()
    }
  }

  private extractValues() {
    const convertToLowerCaseWithTrim = (fieldValue: any) => String(fieldValue ?? '').trim().toLowerCase();
    if (!this.field?.value?.includes("|")) 
    {
      let queueValue = this.queueOptions?.find(x => x.Name === this.field.value)?.Value;
      let issueValue = '';let categoryValue = '';let subjectValue = '';
        this.group?.Fields?.forEach(field => {
          if (field.Name === 'Subject') {
             subjectValue = field.value
          }else if (field.Name === 'CaseCategory') {
             categoryValue = field.value
          }else if (field.Name === 'Issue') {
            issueValue = field.value
          }
      });

      if(!queueValue && (!issueValue || !categoryValue || !subjectValue)){
        this.selectedQueue = '-1';
        this.selectedAgent = '-1';
      }else{
        let cachedSCIData = JSON.parse(this.flexStore.get('sciData'));

        const issueFieldObject =
              cachedSCIData
            ?.find(x => convertToLowerCaseWithTrim(x.Value) === convertToLowerCaseWithTrim(subjectValue))
            ?.FieldOptions?.find(y => convertToLowerCaseWithTrim(y.Value) === convertToLowerCaseWithTrim(categoryValue))
            ?.FieldOptions?.find(z => convertToLowerCaseWithTrim(z.Value) === convertToLowerCaseWithTrim(issueValue));

				let issueQueueID = (issueFieldObject?.UserSegmentationID == null) ? this.queueServices.getselectedQueueId() : issueFieldObject?.UserSegmentationID;
        this.selectedQueue = issueQueueID;
        this.selectedAgent = '-1';
      }
    } 
    else if (this.field.value) 
    {
      this.selectedQueue = this.field.value.substring(0, this.field.value.indexOf("|"));
      this.selectedAgent = this.field.value.substring(this.field.value.indexOf("|") + 1);
      this.emitSelection();
    }
    else 
    {
      this.selectedQueue = '-1';
      this.selectedAgent = '-1';
      this.emitSelection();
    }
    if(this.selectedQueue != '-1'){
      this.getAgents();
    }else{ this.disableBlocker(false);}
  } 
  disableBlocker(val:boolean): void {
  this.dialerService.setIsBlockLoader(val);
  this.loaderService.display(val);
}
}
